import { render, staticRenderFns } from "./TeamArtistReview.vue?vue&type=template&id=628ac09e&scoped=true"
import script from "./TeamArtistReview.vue?vue&type=script&lang=js"
export * from "./TeamArtistReview.vue?vue&type=script&lang=js"
import style0 from "./TeamArtistReview.vue?vue&type=style&index=0&id=628ac09e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628ac09e",
  null
  
)

export default component.exports